import React, { useEffect, useRef, useState } from "react";
import Wrapper from "../Components/Wrapper";
import GameHeading from "../Components/GameHeading";
import GameDescription from "../Components/GameDescription";
import Buttons from "../Components/Buttons";
import Button from "../Components/Button";
import { useContext, useRef } from "react";
import {MemoryLevelContext} from "../Context/MemoryLevelContext";
import ReturnButton from "../Components/ReturnButton";
import BigBurst from "../Animation/StarBling";
import useMediaQuery from "../Hooks/useMediaQuery";


const MemoryStart = () => {

    //Retrieving context what level the user has chosen
    const {levels, levelList, stageList, setWrapperHeight, displayTimer, setDisplayTimer} = useContext(MemoryLevelContext);

    const levelName = levels.level.levelName; //retrurns string with levelname
    const levelIsSet = levels.level.levelIsSet; // returns boolean
    const stageIsSet = levels.stage.stageIsSet; // returns boolean

    const heading = "Hur spelar jag?";
    const description = "In ipsum quidem eum sunt voluptas aut porro molestiae ut dolore omnis est aliquam optio. Non molestiae maiores vel vitae maxime qui totam consectetur vel optio voluptatem qui officiis rerum!";

    const currentSubStages = levelList.filter(level => level.stageId == levels.level.level).map(level => level.subStages).flat();

    // If a first level is set add open class to memory-second-page
    const [openSubLevels, setOpenSubLevels] = useState(false);
    useEffect(() => {
        if(levelIsSet){
            setTimeout(() => {          // set delay of ms to activate slide in transition
                setOpenSubLevels(true);
            }, 10)
        } else{ 
            setOpenSubLevels(false);
        }

        scrollTo(0, 0);
    }, [levelIsSet]);

    
    //NEW
    const ref = useRef(null);
    useEffect(() => {
        //TODO need to look at a solution to make wrapper height dynamic depending of child
        document.addEventListener("DOMContentLoaded", () => {
            setWrapperHeight(ref.current.clientHeight);
        });  
    }, [ref, levelIsSet]);

    const isBigScreen = useMediaQuery('(min-width: 64rem)');

    return(
         <>
            <Wrapper background={"#ffeacb"}>
                <div ref={ref} className={`memory-first-page ${levelIsSet ? "close" : ""}`}>
                    <GameHeading title={"Matcha kort"} />
                    <GameDescription heading={heading} description={description}/>
                    {/* <Buttons title={"Välj spelnivå"} levels={levelList}/> */}
                    <div className="level-buttons-container">
                        <h3>Redo att starta spelet?</h3>
                        <div className="buttons">
                            { levelList.map(({stage, stageId}) => {
                                return (<Button name={stage} value={stageId} key={stageId}/>)
                            })}
                        </div>
                    </div>
                </div>
                
                {levelIsSet && 
                <div className={`memory-second-page ${openSubLevels ? "open" : ""}`}>
                    <GameHeading title={"Välj spelnivå"} />
                    {/* <Buttons title={"Välj spelnivå"} levels={currentSubStages}/> */}
                    
                    <div style={{marginTop: isBigScreen ? "" : "40px"}} className="level-buttons-container">
                        {/* <h3>Välj spelnivå</h3> */}
                        <div className="buttons">
                            { currentSubStages.map(({stage, stageId}) => {
                                return (<Button name={stage} value={stageId} key={stageId}/>)
                            })}
                        </div>
                        <div className="time-switch-container">
                            <span className="time-switch-label">Spela med tidtagning:</span>
                            <label className={`time-switch ${displayTimer ? "checked" : ""}`}>
                                <input type="checkbox" checked={displayTimer} onChange={() => setDisplayTimer((prevValue) => !prevValue)} />
                                <span className={`time-switch-slider round ${displayTimer ? "checked" : ""}`}></span>
                            </label>
                        </div>
                    </div>

                    <ReturnButton />
                </div>
                }
            </Wrapper>   
        </>
    );
};

export default MemoryStart;